import { defineStore } from "pinia";

import { computed, ref, type Ref } from "vue";
import {
  DEFAULT_FREIGHT_ROW,
  type FreightDetailRow,
} from "@/common/types/chargeWeight";
import Config from "@/common/config";
export const useChargeweightPersistedStore = defineStore(
  "chargeweightPersisted",
  () => {
    const weightInput = ref<number>(0);
    const volumeInput = ref<number>(0);
    const detailedCalculation = ref(false);
    const metricMeasurement = ref(true);
    const metricVolumeMeasurement = ref(true);
    const shippingMethods = ref([
      { name: "OCEAN", weight: 0 },
      { name: "AIR", weight: 0 },
      { name: "TRUCK", weight: 0 },
      { name: "COURIER", weight: 0 },
    ]);
    const rows: Ref<FreightDetailRow[]> = ref(
      Array.from({ length: 5 }, createNewRow),
    );

    const completedFreightDetailRows = computed(() => {
      return rows.value.filter((row) => {
        // Check if any of the specified properties are still null
        return (
          row.amount !== null &&
          row.length !== null &&
          row.width !== null &&
          row.height !== null &&
          row.weightPerPiece !== null
        );
      });
    });
    function reset() {
      rows.value = Array.from({ length: 5 }, createNewRow);
      weightInput.value = 0;
      volumeInput.value = 0;
      detailedCalculation.value = false;
      metricVolumeMeasurement.value = true;
      metricMeasurement.value = true;
      resetResults();
    }
    function resetResults() {
      shippingMethods.value.forEach((item) => (item.weight = 0));
    }

    const addRow = () => {
      rows.value.push(createNewRow());
    };

    return {
      weightInput,
      volumeInput,
      detailedCalculation,
      metricMeasurement,
      metricVolumeMeasurement,
      shippingMethods,
      reset,
      resetResults,
      rows,
      addRow,
      completedFreightDetailRows,
    };
  },
  {
    persist: {
      key: Config.chargeweightDataPersistKey,
    },
  },
);
const createNewRow = () => ({
  ...DEFAULT_FREIGHT_ROW,
});
